/* ==========================================================================
   Badge de reducere langa pret — store21 (Ella 6.7.6)
   De salvat ca assets/custom-price-badge.js si inclus in theme.liquid:
     <script src="{{ 'custom-price-badge.js' | asset_url }}" defer></script>

   Acelasi markup .price este folosit si pe card, si pe pagina de produs,
   deci un singur script le acopera pe amandoua.
   Procentul se calculeaza din data-compare / data-last (valori in bani),
   nu din textul afisat — e mai sigur decat sa parsam "349,00 lei".
   ========================================================================== */
(function () {
  'use strict';

  var BADGE_CLASS = 'price-sale-badge';

  function toNumber(value) {
    var n = parseFloat(value);
    return isNaN(n) ? null : n;
  }

  /* Rezerva, daca lipsesc atributele data-: citim textul.
     Format RO: punctul e separator de mii, virgula e zecimala. */
  function fromText(el) {
    if (!el) return null;
    var cleaned = el.textContent.replace(/[^\d.,]/g, '');
    cleaned = cleaned.replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.');
    var n = parseFloat(cleaned);
    return isNaN(n) ? null : n;
  }

  function process(root) {
    var blocks = (root || document).querySelectorAll('.price--on-sale');

    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      var sale = block.querySelector('.price__sale');
      if (!sale) continue;
      if (sale.querySelector('.' + BADGE_CLASS)) continue;

      var compareEl = sale.querySelector('[data-compare]');
      var lastEl = sale.querySelector('[data-last]');

      var compare = compareEl ? toNumber(compareEl.getAttribute('data-compare')) : null;
      var last = lastEl ? toNumber(lastEl.getAttribute('data-last')) : null;

      if (compare === null) compare = fromText(sale.querySelector('.price__compare'));
      if (last === null) last = fromText(sale.querySelector('.price-item--sale'));

      if (!compare || !last || compare <= last) continue;

      var pct = Math.round((compare - last) / compare * 100);
      if (pct < 1) continue;

      var badge = document.createElement('span');
      badge.className = BADGE_CLASS;
      badge.setAttribute('aria-hidden', 'true');
      badge.textContent = '-' + pct + '%';

      /* Badge-ul se insereaza IMEDIAT DUPA pretul vechi, nu la final.
         Asa ordinea din DOM e deja cea dorita (pret vechi, badge, pret nou)
         si nu mai depinde de "order" din CSS, pe care tema il suprascria. */
      if (compareEl && compareEl.parentNode === sale) {
        sale.insertBefore(badge, compareEl.nextSibling);
      } else {
        sale.appendChild(badge);
      }
    }
  }

  function run() {
    try { process(document); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Preturi randate din nou: schimbarea variantei pe pagina de produs,
     quick view, filtrare de colectie, paginare AJAX. */
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(run, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();